import '../../assets/components/Layout/Column.css';//#region lib/components/Layout/Column.module.css
var e = "_column_19gxm_1", t = { column: e };
//#endregion
export { e as column, t as default };
